import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FormGenerator from "../../../core/form-generator";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import { formatDate } from "../../../utils";
import { Box, Button, Grid, Stack, TextField } from "@mui/material";
import { DATE_FORMATS } from "../../../utils/constants";
import FormContainer from "../../../core/form-container";
import CustomButtonComponent from "../../../core/custom-button";
import { Icon } from "@iconify/react";
import {
  FOC_FORM_COFIG1,
  FOC_FORM_COFIG3,
  FOC_FORM_CONFIG4,
  FOC_FORM_CONFIG_ADDRESS,
  SERVICE_TABLE_HEADERS,
} from "../../../components/ticket-form/helper";
import SiTextField from "../../../core/si-textfield";
import PreviewFormGenerator from "../../../core/preview-form-generator";
import ThumbUpAltTwoToneIcon from "@mui/icons-material/ThumbUpAltTwoTone";
import ThumbDownOffAltTwoToneIcon from "@mui/icons-material/ThumbDownOffAltTwoTone";
import { generateFOCPDF } from "./config";
import CustomModal from "../../../core/modal";
const ViewFoc = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [files, setFiles] = useState([]);
  const [recommandedParts, setRecommandedParts] = useState([
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
  ]);
  const [focReleaseRequest, setFocReleaseRequest] = useState([
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
    { partNumber: "", description: "", qty: "" },
  ]);
  const [rejectModal, setRejectModal] = useState({
    isOpen: false,
    reason: "",
  });
  const cleanedRecommandedParts = () =>
    recommandedParts.filter(
      (part) => part.partNumber && part.description && part.qty
    );

  const cleanedFocReleaseRequest = () =>
    focReleaseRequest.filter(
      (part) => part.partNumber && part.description && part.qty
    );
  const loadData = (isDownload = false) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.STAGE_VIEW}/${id}`,
      null
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          const { foc } = res.ticket;
          setFormData({
            ...foc,
            line1: foc?.address?.line1,
            line2: foc?.address?.line2,
            line3: foc?.address?.line3,
            city: foc?.address?.city,
            state: { label: foc?.address?.state, value: foc?.address?.state },
            pinCode: foc?.address?.pinCode,
            oemName: res?.complaintForm?.oemName,
            warrantyClaimNo: foc?.focReleaseRequest?.warrantyClaimNo,
            date: foc?.date
              ? formatDate(foc?.date, DATE_FORMATS["DD-MM-YYYY"])
              : "",
            failureDate: foc?.failureDate
              ? formatDate(foc?.failureDate, DATE_FORMATS["DD-MM-YYYY"])
              : "",
            installationDate: foc?.installationDate
              ? formatDate(foc?.installationDate, DATE_FORMATS["DD-MM-YYYY"])
              : "",
          });
          setRecommandedParts(foc?.partsReplacement);
          setFocReleaseRequest(foc?.focReleaseRequest?.partsData);
          setFiles(foc?.attachments);
        }
      })
      .catch((err) => console.error(err));
  };
  const updateFocStatus = (status = "", reason = "") => {
    const payload = {
      focStatus: status,
    };
    if (status === "REJECTED" && reason) {
      payload.rejectionComment = reason;
    }
    if (status) {
      invokeApi(
        HTTP_METHODS.PUT,
        `${HOSTNAME}${REST_URLS.FOC}/approval/${id}`,
        payload
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          } else {
            toast.success("Updated Successfully");
            navigate(-1);
          }
        })
        .catch((err) => console.error(err));
    }
  };
  const downloadFoc = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.FOC}/approval/${id}`,
      null,
      { download: "TRUE" }
      // "blob"
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          generateFOCPDF(res.focPdf);
        }
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="page-body page-load">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className=" view-detailed-ticket">
          <ArrowBackIcon
            sx={{ cursor: "pointer", marginRight: "20px" }}
            onClick={() => {
              navigate(-1);
            }}
          />
          <div>
            <p className="tab-name">Service Support</p>
            <p className="section-name">FOC Release Request Form</p>
          </div>
        </div>

        <Box sx={{ display: "flex" }}>
          {formData?.focStatus === "SUBMITTED" ? (
            <div>
              <CustomButtonComponent
                variant="contained"
                color="success"
                sx={{ mr: 1 }}
                onClick={() => updateFocStatus("COMPLETED")}
                startIcon={<ThumbUpAltTwoToneIcon />}
              >
                Approve
              </CustomButtonComponent>
              <CustomButtonComponent
                variant="contained"
                color="error"
                sx={{ ml: 1, mr: 6 }}
                onClick={() => {
                  setRejectModal({ isOpen: true, reason: "" });
                }}
                startIcon={<ThumbDownOffAltTwoToneIcon />}
              >
                Reject
              </CustomButtonComponent>
            </div>
          ) : (
            <CustomButtonComponent
              variant="contained"
              color="success"
              startIcon={
                <Icon
                  icon="solar:download-bold-duotone"
                  width="1.2rem"
                  height="1.2rem"
                  style={{ color: "white" }}
                />
              }
              onClick={downloadFoc}
              sx={{ mr: 6 }}
            >
              Download
            </CustomButtonComponent>
          )}
        </Box>
      </Box>
      <FormContainer className="mt-0">
        <PreviewFormGenerator
          formConfig={FOC_FORM_COFIG1}
          formValues={formData}
        />

        <p>Address</p>
        <PreviewFormGenerator
          formConfig={FOC_FORM_CONFIG_ADDRESS}
          formValues={formData}
        />
        <PreviewFormGenerator
          formConfig={FOC_FORM_COFIG3}
          formValues={formData}
        />
        <div>
          <Grid container>
            <Grid md={4} sx={{ pr: 3 }}>
              <p>Free Service Carried Out</p>

              <SiTextField
                disabled={true}
                value={formData.freeServicesCarriedOut}
              />
            </Grid>
            <Grid md={4} sx={{ pr: 3 }}>
              <p>Part Claim No. if any</p>
              <SiTextField
                name="pastClaimIfAny"
                disabled={true}
                value={formData?.pastClaimIfAny || ""}
                placeholder="Part Claim No."
              />
            </Grid>
          </Grid>

          <div>
            <p>Parts Recommended for Replacement</p>
            <div className="ph-table">
              {cleanedRecommandedParts().length > 0 && (
                <div className="foc-header pht-header table-header-bg">
                  <span>Part No.</span>
                  <span>Description</span>
                  <span>Qty</span>
                </div>
              )}
              {cleanedRecommandedParts().map((item, index) => {
                return (
                  <div className="foc-header pht-header">
                    <span>{item.partNumber}</span>
                    <span>{item.description}</span>
                    <span>{item.qty}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <PreviewFormGenerator
          formConfig={FOC_FORM_CONFIG4(true)}
          formValues={formData}
        />
        <div>
          <p>FOC Release Request</p>
          <div className="ph-table">
            <div className="foc-header pht-header table-header-bg">
              <span>Part No.</span>
              <span>Description</span>
              <span>Qty</span>
            </div>

            {cleanedFocReleaseRequest().map((item, index) => {
              return (
                <div className="foc-header pht-header">
                  <span>{item.partNumber}</span>
                  <span>{item.description}</span>
                  <span>{item.qty}</span>
                </div>
              );
            })}
          </div>
        </div>
        <div>
          <Grid container spacing={5} sx={{ mt: 1 }}>
            <Grid item md={5.7}>
              <Box
                sx={{
                  backgroundColor: "#F4F5F9",
                  borderRadius: "4px",
                  border: "1px solid #DBDCDE",
                  height: "130px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {formData?.oemSign && (
                  <img
                    src={formData.oemSign}
                    alt="signature"
                    width="70%"
                    height="60%"
                  />
                )}
              </Box>
              <p style={{ textAlign: "center" }}>
                Dealer/ OEM Seal & Signature
              </p>
            </Grid>
            <Grid item md={5.7}>
              <SiTextField
                name="oemServiceComment"
                type="text"
                onChange={(e) =>
                  setFormData((prevVal) => ({
                    ...prevVal,
                    oemServiceComment: e.target.value,
                  }))
                }
                multiline
                value={formData.oemServiceComment}
                rows={5}
                disabled={true}
              />
              <p style={{ textAlign: "center" }}>OEM Service H.O comments</p>
            </Grid>
          </Grid>
          {files.map((r, index) => {
            return (
              <div key={r.blobName + index}>
                {r.blobName ? (
                  <span>{r.blobName}</span>
                ) : (
                  <a href={r} target="_blank">{`Attachment ${index + 1}`}</a>
                )}
              </div>
            );
          })}
        </div>
      </FormContainer>

      {rejectModal.isOpen && (
        <CustomModal
          title="Reject FOC Release Request"
          onClose={() =>
            setRejectModal((prev) => ({ isOpen: false, reason: "" }))
          }
        >
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            <TextField
              fullWidth
              id="reason"
              label="Reason"
              sx={{ m: 1 }}
              onChange={(e) =>
                setRejectModal((prev) => ({ ...prev, reason: e.target.value }))
              }
              value={rejectModal.reason}
              size="small"
              multiline
              rows={4}
            />

            <Stack
              direction="row"
              spacing={2}
              sx={{ m: 1, justifyContent: "flex-end" }}
            >
              <Button
                variant="outlined"
                color="error"
                fullWidth
                onClick={() => {
                  setRejectModal((prev) => ({ isOpen: false, reason: "" }));
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={!rejectModal.reason}
                onClick={() => {
                  updateFocStatus("REJECTED", rejectModal?.reason);
                  setRejectModal((prev) => ({ isOpen: false, reason: "" }));
                }}
              >
                Save
              </Button>
            </Stack>
          </Box>
        </CustomModal>
      )}
    </div>
  );
};

export default ViewFoc;
